// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function removeEmptyProperties<T extends Record<string, any>>(
  obj: T
): Partial<T> {
  return Object.entries(obj).reduce((acc, [key, value]) => {
    if (typeof value !== 'undefined' && value !== null && value !== '') {
      acc[key] = value;
    }
    return acc;
  }, {});
}
